export const Addresses = {
    icons: {
        TOGGLE_SIDE_MENU : '/assets/images/icons/side-menu-toggle-icon.svg' ,
        SHOWN_PASSWORD : "/assets/images/icons/hide-password.svg" ,
        HIDEN_PASSWORD : "/assets/images/icons/show-password-icon.svg" ,
        CLOSE_MODAL_X : "/assets/images/icons/close-modal-x.svg" ,
        CLOSE_MODAL_X_RED : "/assets/images/icons/close-modal-x-red.svg" ,
        SELECT_INPUT_ARROW : "/assets/images/icons/select-input-arrow.svg" ,
        REQUIRE_MARK : '/assets/images/icons/requireMark.svg' ,
        HOME : '/assets/images/icons/home.svg' ,
    },
    images: {
        LOGIN_BACKGROUND : "/assets/images/login-back-img.jpg",
        PROFILE_PICTURE : "/assets/images/profile-picture.png",
        MAP_MARKER : "/assets/images/marker-icon.png",
        PAGE_404 : "/assets/images/page-404-img.png",
    }
}